import { scenes } from "../scenes";
import { Scene, Choice } from "../models";

export class BankExterior extends Scene {
  async init() {
    this.title = "The Bank";
    this.image = require("@/images/Bank.png");
    this.audio = null;
    this.description = "";
  }

  get options(): any[] {
    return [
      new Choice("Enter the bank ", async () => {
        if (this.state.storylines.infectedWithYogid) {
          this.description = "SONNY YANG: I need to find that SANITIZER!";
          this.audio = require("@/audio/Pandemic-182-Sonny-MP3.mp3")
        } else {
          await this.navigate(scenes.BankInterior());
        }
      }),
      new Choice("Go Left", async () => {
        await this.navigate(scenes.DarethsHouseExterior());
      }),
      new Choice("Go Right", async () => {
        await this.navigate(scenes.BelovedOldPub());
      }),
    ];
  }
}

export default new BankExterior();
